import dadosAgenciaComum from './dadosAgenciaComum';

export const dadosMarinhoViagens = {
    ...dadosAgenciaComum,
    id: 'marinhoviagens',
    nome: 'Marinho Viagens',
    instagram: 'instagram.com',
    facebook: 'facebook.com',
    youtube: 'youtube.com',
    email: 'suportevexado@gmail.com',
    idsTagManager: ['GTM-5VM2TLJ']
};
